<template>
  <div :class="$style.customAttributeContainer">
    <RadiusReplyAttributes
      v-if="areServersAvailable"
      parentType="user_group"
    />
    <h3
      v-if="areServersAvailable"
      :class="$style.header"
    >
      {{ getHeaderText }}
    </h3>
    <RadiusItemTable
      :boundItemsUrl="boundItemsUrl"
      :inDetailsAsidePanel="inDetailsAsidePanel"
      :panelType="panelType"
    />
  </div>
</template>

<script>
import { StoreModelMap } from 'client/util/Constants';
import { mapGetters, mapState } from 'vuex';
import AsidePanelChildComponentMethodsMixin from 'client/components/AsidePanel/mixins/AsidePanelChildComponentMethodsMixin';
import AsidePanelChildComponentPropsMixin from 'client/components/AsidePanel/mixins/AsidePanelChildComponentPropsMixin';
import RadiusItemTable from 'client/Radius/RadiusItemTable.vue';
import RadiusReplyAttributes from 'client/Radius/RadiusReplyAttributes';

export default {
  name: 'RadiusUserGroupWrap',

  components: {
    RadiusItemTable,
    RadiusReplyAttributes,
  },

  inject: ['$validator'],

  mixins: [
    AsidePanelChildComponentMethodsMixin,
    AsidePanelChildComponentPropsMixin,
  ],

  props: {
    boundItemsUrl: {
      default: '',
      type: String,
      required: true,
    },
    inDetailsAsidePanel: {
      default: false,
      type: Boolean,
      required: true,
    },
    panelType: {
      default: '',
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapGetters('RadiusServerCollection', {
      totalServers: 'getTotalCountOfAllItems',
    }),

    areServersAvailable() {
      return this.totalServers > 0;
    },

    getHeaderText() {
      if (this.isItemBeingCreated) {
        return 'This user group is bound to the following RADIUS servers: ';
      }

      return `${this.displayName} user group is bound to the following RADIUS servers: `;
    },
  },

  beforeCreate() {
    this.$options.methods.asidePanelChildComponentHandleBeforeCreate(this.$options);
    const userGroupModel = StoreModelMap[this.$options.propsData.parentType];

    this.$options.computed = {
      ...this.$options.computed,
      ...mapGetters(userGroupModel, [
        'isItemBeingCreated',
      ]),
      ...mapState(userGroupModel, { displayName: state => state.item.name }),
    };
  },
};
</script>

<style module>
@value (jcGrey600) from '~css/brand-colors.css';

.customAttributeContainer {
  height: 100%;
  overflow: scroll;
  padding: 10px 20px 10px;
  width: 100%;
}

.header {
  color: jcGrey600 !important;
  font-size: 1.1rem !important;
  font-weight: 700 !important;
  margin: 0 !important;
  padding: 20px 20px 3px !important;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
